import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../store';
import MediaPickerLoadMoreCard from '../../common/MediaPickerLoadMoreCard';
import MediaPickersConstants from '../../MediaPickersConstants';

const BackgroundAssetLoadMoreCard = ({
    backgroundAssetsPageNumber,
    backgroundAssetsLoading,
    galleryCardWidth,
    galleryCardHeight,
    loadUserBackgroundAssets
}) => {
    const onLoadMoreButtonClick = () => {
        loadUserBackgroundAssets(backgroundAssetsPageNumber + 1, MediaPickersConstants.USER_ASSETS_PER_PAGE);
    }

    return (
        <MediaPickerLoadMoreCard
            key={'load-more-button'}
            onLoadMoreButtonClick={onLoadMoreButtonClick}
            isLoading={backgroundAssetsLoading}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        backgroundAssetsPageNumber,
        backgroundAssetsLoading
    } = state.mediaPicker;

    return {
        backgroundAssetsPageNumber,
        backgroundAssetsLoading
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const loadUserBackgroundAssets = (pageNumber, itemsPerPage) => dispatch(mediaPickerActions.loadUserBackgroundAssets(pageNumber, itemsPerPage));

    return {
        setProperty,
        loadUserBackgroundAssets
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundAssetLoadMoreCard);